import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {Button, Card, Grid, useMediaQuery} from "@mui/material";
import Select from "react-select";
import MiniMap from "./components/MiniMap";
import logo from './assets/logo.svg';
import LocationSelectForMain from "./components/LocationSelectForMain";
import {InfoTwoTone, PinDropTwoTone, PinTwoTone, WhatsApp} from "@mui/icons-material";
import Header from "./components/Header";
import {API_URL} from "./config";
import MiniMapOpenLocation from "./components/MiniMapOpenLocation";
import LegalPopup from "./components/LegalPopup";
import Typography from "@mui/material/Typography";
import Footer from "./components/Footer";


export default function SearchDoctor() {

    const [center, setCenter] = useState({lat: 41.0082, lng: 28.9784});
    const [marker, setMarker] = useState(center);
    const [map, setMap] = useState();
    const [doctorList, setDoctorList] = useState([]);
    const [city, setCity] = useState('');
    const [district, setDistrict] = useState('');
    const [selectedBrans, setSelectedBrans] = useState();
    const [loading, setLoading] = useState(false);
    const isMobile = useMediaQuery("(max-width:768px)");

    const fetchRef = useRef(false); // useRef, bileşen yeniden render edilse bile aynı kalır

    useEffect(() => {
        if (fetchRef.current) return; // Eğer fetchRef true ise (ilk çalışmadan sonra) return eder
        fetchRef.current = true; // İlk çalışmada fetchRef'i true yapar

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                ({coords}) => {
                    fetchNearestDoctors(coords.latitude, coords.longitude);

                },
                () => {
                    console.error('Konum erişimi reddedildi.');
                }
            );
        }
    }, [map]); // map bağımlılık dizisinde kalabilir

    const fetchNearestDoctors = (latitude, longitude) => {
        let date = new Date();
        setLoading(true);
// GMT+3'e göre ayarla
        let gmtPlus3Date = new Date(date.getTime() + 3 * 60 * 60 * 1000);
// ISO formatında tarihi al ve biçimlendir
        let formattedDate = gmtPlus3Date.toISOString().slice(0, 19).replace('T', ' ');
        axios.get(`${API_URL}/nearest-doctors/`, {
            params: {
                latitude: latitude,
                longitude: longitude,
                date_time: formattedDate
            }
        })
        .then(response => {
           console.log(response.data.length>0 ? 'veri var': 'veriyok');
            setDoctorList(response.data);
            setLoading(false);
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    };


     const trackClick = async (doctorId, eventType) => {
    await fetch(`${API_URL}/doctors/${doctorId}/click`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ event_type: eventType }),
    });
  };
  const formatPhoneNumberForWhatsApp = (phoneNumber) => {
    // Telefon numarasını +90 ülke koduyla uluslararası formata çevir
    const cleanedNumber = phoneNumber.replace(/\D/g, ''); // Sadece sayıları al
    const internationalNumber = `90${cleanedNumber.slice(1)}`; // Başındaki 0'ı çıkar ve 90 ekle
    return `https://wa.me/${internationalNumber}`;
  };

  const handleWhatsAppClick = (doctorId, phoneNumber) => {
    const whatsappLink = formatPhoneNumberForWhatsApp(phoneNumber);
    trackClick(doctorId, 'whatsapp_click');
    window.open(whatsappLink, '_blank');
  };

  const handleMapClick = (doctorId, coordinates) => {
    trackClick(doctorId, 'map_click');

    let mapLink= `https://www.google.com/maps?q=${coordinates.lat},${coordinates.lng}`

    window.open(mapLink, '_blank');
  };

    function findDoctor() {
        let date = new Date();

// GMT+3'e göre ayarla
        let gmtPlus3Date = new Date(date.getTime() + 3 * 60 * 60 * 1000);
// ISO formatında tarihi al ve biçimlendir
        let formattedDate = gmtPlus3Date.toISOString().slice(0, 19).replace('T', ' ');
        axios.post(`${API_URL}/doctors-list/`, {
                city: city,
                district: district,
                department: selectedBrans,
                date_time: formattedDate,
                user_coordinates: {
                    latitude: marker.lat,
                    longitude: marker.lng
                }
        })
            .then(response => {
               // console.log(response.data);
                setDoctorList(response.data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    return (
        <div className="App">
        <Header />
            <main>
                <p style={{
                    border: 'darkgray 1px solid',
                    width: isMobile ? '99%':'70%',
                    borderRadius: '5px',
                    margin: '0 auto',
                    minHeight: '80px',
                    alignContent: isMobile ? 'left':'center',
                    backgroundColor: 'lightblue'
                }}><InfoTwoTone color={'info'}/> Lütfen konum izni veriniz. Konumunuz doğru olarak saptandığında
                    yakınınızdaki şu anda ulaşabileceğiniz hastane/doktorlar listelenecektir.
                    Dilerseniz aşağıdan il ve ilçe seçerek de arama yapabilirsiniz.
                    <br/>
                    Bu platform sağlık hizmeti vermemektedir, yalnızca listeleme amaçlıdır ve içerisindeki bilgilerdeki hatalardan veya eksikliklerden dolayı hiçbir hukuki sorumluluğu bulunmamaktadır.
                    Olası olumsuzluklardan kaçınmanız için öncelikle sağlık sunucunuzla iletişime geçmeniz önerilir.
                </p>

                <p></p>
                <form className="search-form">
                    <LocationSelectForMain setCity={setCity} setDistrict={setDistrict}/>
                    <Button variant={'contained'} color={'info'} onClick={() => {
                        findDoctor()
                    }}>Bul</Button>
                </form>


                <div style={{padding: '10px', textAlign: 'center'}}>
                    <LegalPopup />

                    <h2>Bulunan Doktorlar: </h2> (Mesafeye göre sıralanmaktadır)
                    {
                        doctorList.length > 0 &&
                        doctorList.map((doctor, index) => {
                                return (

                                    <div key={index}>

                                        <Card style={{
                                            textAlign: "left",
                                            width: isMobile ? '99%':'40%',

                                            backgroundColor: '#f8f6f6',
                                            margin: '0 auto ',
                                            boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
                                        }}>
                                            <Grid container >
                                                {
                                                    doctor.info.profile_photo &&
                                                    <Grid item sm={2} xs={6}>
                                                        <img src={'data:image/JPEG;base64,'+doctor.info.profile_photo} width={'120px'} />
                                                    </Grid>
                                                }


                                                <Grid item sm={5} xs={12}>
                                                    <h4>{doctor.info.name}</h4>
                                                    <h4>{doctor.info.hospital}</h4>
                                                    <p>{doctor.info.address} {doctor.info.district} / {doctor.info.city} </p>
                                                    <h4 style={{color:'red'}}>Kapanış : {doctor.shift[0].end_hour}</h4>

                                                    <p>Konumunuza olan mesafe (Konum izniniz açıksa doğru gösterilir): {doctor.distance.toFixed(3)} KM</p>
                                                    {doctor.info.whatsapp &&

                                                        <Button
                                                            size={'small'}
                                                            onClick={() => handleWhatsAppClick(doctor.info.id, doctor.info.whatsapp)}
                                                            className="whatsapp-link" color={'success'} variant={'contained'}
                                                        >
                                                            <WhatsApp />
                                                            WhatsApp

                                                        </Button>}

                                                  <Button
                                                      size={'small'}
                                                        onClick={() => handleMapClick(doctor.info.id, doctor.info.coordinates)}
                                                        className="map-link" variant={'contained'}
                                                    >
                                                        <PinDropTwoTone />
                                                        Haritayı Aç
                                                    </Button>
                                                </Grid>
                                                <Grid item sm={4} xs={12}>
                                                    {doctor.info?.insurance?.selectedOption?.length > 0 && (
                                                        <p>
                                                            <strong>Anlaşmalı Sigortalar</strong>
                                                            { doctor.info.insurance.selectedOption.map((data,index)=>{
                                                                return (
                                                                    <li key={index}> {data.label}</li>
                                                                )
                                                            }) }
                                                        </p>)
                                                    }
                                                    {doctor.info?.services?.selectedOlanak?.length > 0 && (
                                                        <p>
                                                            <strong>Sunulan Hizmetler</strong>
                                                            { doctor.info.services.selectedOlanak.map((data,index)=>{
                                                                return (
                                                                    <li key={index}> {data.label}</li>
                                                                )
                                                            }) }
                                                        </p>)
                                                    }
                                                </Grid>
                                            </Grid>






                                            <MiniMapOpenLocation coordinates={[doctor.info.coordinates.lat,doctor.info.coordinates.lng]} doctor={doctor}/>
                                        </Card>
                                        <hr style={{borderStyle:"dotted", borderColor:'#ccc'}}></hr>
                                    </div>

                                )

                            }
                        )
                    }
                </div>
            </main>
    <Footer />



        </div>
    )
}
